import React, { useState } from "react";

const formData = [
  {
    formName: "Arrears",
    plans: [
      {
        title: "D.A. Arrears Calculator",
        price: "₹0",
        features: ["PDF downloadable", "One time payment", "D.A. Arrears applicable from 1st July 2024 onward.", "Email Delivery"],
        redirectUrl: "/daArrearsForm",
      },
      {
        title: "7th Pay Commission Calculator",
        price: "₹12 (for arrears period of one month)",
        features: ["PDF + Excel downloadable", "One time payment", "Covers arrears from 01 Jan 2016 to present", "Email Delivery"],
        redirectUrl: "/arrearesSeventh",
      },
    ],
  },
  {
    formName: "Senior College",
    plans: [
      {
        title: "Placement Form",
        price: "₹249",
        features: ["PDF downloadable", "One time payment", "Email Delivery"],
        redirectUrl: "/srPlacementForm"
      },
    ],
  },
];

const primaryGreen = "#4CAF50";

const FormPricing = () => {
  const [activeForm, setActiveForm] = useState(0);

  const handleRedirect = (redirectUrl) => {
    window.location.href = redirectUrl;
  };

  return (
    <div className="min-h-screen bg-gray-50 px-4 sm:px-6 lg:px-8 pt-20 pb-16 mt-16" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Pricing
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose the correct form for your needs.
          </p>
        </div>

        {/* Form Category Selection */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {formData.map((form, index) => (
            <button
              key={index}
              onClick={() => setActiveForm(index)}
              className={`px-5 py-2.5 text-sm sm:text-base font-medium rounded-md transition-all duration-200 ${
                activeForm === index 
                  ? 'text-white'
                  : 'text-gray-700 bg-white border border-gray-200 hover:border-gray-300'
              }`}
              style={{
                backgroundColor: activeForm === index ? primaryGreen : '',
                fontFamily: "'Poppins', sans-serif"
              }}
            >
              {form.formName}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {formData[activeForm].plans.map((product, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300"
            >
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl font-semibold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>{product.title}</h3>
                </div>

                <div className="mb-6">
                  <p className="text-2xl font-bold" style={{ color: primaryGreen, fontFamily: "'Montserrat', sans-serif" }}>
                    {product.price}
                    {product.price === "₹0" && (
                      <span className="text-base font-normal text-gray-500 ml-2">Free</span>
                    )}
                  </p>
                </div>

                <ul className="space-y-3 mb-8">
                  {product.features.map((feature, i) => (
                    <li key={i} className="flex items-start">
                      <svg 
                        className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" 
                        style={{ color: primaryGreen }} 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => handleRedirect(product.redirectUrl)}
                  className={`w-full py-3 px-4 rounded-md font-medium transition-colors duration-200 ${
                    product.price === "₹0"
                      ? 'bg-green-50 text-green-700 hover:bg-green-100'
                      : 'text-white hover:bg-green-600'
                  }`}
                  style={{
                    backgroundColor: product.price === "₹0" ? '' : primaryGreen,
                    border: product.price === "₹0" ? `1px solid ${primaryGreen}` : 'none',
                    fontFamily: "'Poppins', sans-serif"
                  }}
                >
                  {product.price === "₹0" ? 'Go to Form' : `Go to ${product.title}`}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="mt-12 text-center text-gray-500 text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
          <p>Need assistance with our forms? <a href="/ContactPage" className="hover:underline" style={{ color: primaryGreen }}>Contact support</a></p>
        </div>
      </div>

      {/* Font Import */}
      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&display=swap');
      `}</style>
    </div>
  );
};

export default FormPricing;